// extracted by mini-css-extract-plugin
export default {"blur":"MainPage_blur__IL3X7","heroWrapper":"MainPage_heroWrapper__GZ+5p","mainContent":"MainPage_mainContent__d+k6N","placeHolder":"MainPage_placeHolder__k9Hxr"};